import { useQuery } from '@tanstack/react-query';
import { fetchCountries } from '../../apis/profile';

const useCountries = () => {
  return useQuery({
    queryKey: ['countries'],
    queryFn: async () => {
      const response = await fetchCountries();
      return response?.data || [];
    },
  });
};

export default useCountries;
